import { Paragraph } from '@zillow/constellation-10';

const PetPolicyWizardTipContent = () => {
  return (
    <div data-testid="WizardTipContent">
      <Paragraph css={{ marginBottom: '400' }}>
        59% of renters have at least one pet.* Allowing pets may attract more applicants.
      </Paragraph>
      <Paragraph textStyle="body-xs" color="text.subtle">
        *Source: Zillow Consumer Housing Trends Report 2023
      </Paragraph>
    </div>
  );
};

export default PetPolicyWizardTipContent;
